import React from "react";
import Link from "next/link";
import MaterialModal from "components/modal/MaterialModal";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

/* 보관함 모달 */
const MainPageModal = ({ modalVisible, closeModal }) => {
  return (
    // <Modal visible={modalVisible} width="450" height="250" effect="fadeInUp" onClickAway={() => closeModal()}>
    <MaterialModal open={modalVisible} closeModal={closeModal}>
      {/* <div className="popup-wrap"> */}
      <div className="popup-content">
        <div className="popup-header">
          <IconButton aria-label="close" className="w-15 h-15" onClick={closeModal}>
            <CloseIcon />
          </IconButton>
        </div>
        <div className="popup-body flex flex-col justify-center items-center">
          <h3 className="text-2xl text-primary font-bold font-gmarket-medium" id="modal-title">
            작성하신 이메일로 비밀번호 변경
          </h3>
          <h3 className="text-2xl text-primary font-bold font-gmarket-medium" id="modal-title">
            메일이 전송되었습니다
          </h3>
          <p className="mb-0 text-888 font-gmarket-medium">비밀번호 변경 후 로그인 해 주세요.</p>
        </div>
        <div className="popup-footer center">
          {/* <button type="button" className="btn btn-grayPrimary w-1/2 mr-2" onClick={() => closeModal()}>
            확인
          </button> */}
          <Link href="/">
            <div className="btn btn-modal-o">마켓으로 이동하기</div>
          </Link>
        </div>
      </div>
      {/* </div> */}
    </MaterialModal>
  );
};

export default MainPageModal;
